import { render, staticRenderFns } from "./ContentRiskMessages.vue?vue&type=template&id=a481f1a0&scoped=true&lang=html"
import script from "./ContentRiskMessages.vue?vue&type=script&lang=js"
export * from "./ContentRiskMessages.vue?vue&type=script&lang=js"
import style0 from "./ContentRiskMessages.vue?vue&type=style&index=0&id=a481f1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a481f1a0",
  null
  
)

export default component.exports